import axios from "axios";

// A dedicated axios instance for the Work Scheduler (Periodical) module,
// pointed directly at the real Periodical API — same convention as the
// Cleaning Audit and Laundry Audit modules (bypassing MajesticERP-PeridicalWeb's
// own Express mask, which added no logic of its own beyond path proxying and,
// in a couple of places, renaming/reshaping a request — see workScheduler/index.js
// header comment for the specific renames found).
//
// Unlike both siblings, this API's CORS is already correctly registered via
// server.pre() (not just .use()) — no CORS fix needed here.
//
// This deliberately does NOT share MyM's own client (src/utils/interceptors/axios.js)
// or its errorInterceptor, which clears localStorage and redirects to /login on
// any 401+ — a Work-Scheduler-only auth hiccup must never log the whole app out.
const periodicalClient = axios.create({
  baseURL: process.env.REACT_APP_PERIODICAL_API_URL,
  headers: {
    "content-type": "application/json",
    accept: "application/json",
  },
});

export default periodicalClient;
